{
  "v8c.webhooks.actif": "Actif",
  "v8c.webhooks.activation.active": "Webhook activé : les événements abonnés lui sont livrés.",
  "v8c.webhooks.activation.activer": "Activer le webhook",
  "v8c.webhooks.activation.confirmation_activer": "Activer ce webhook ? Les événements abonnés lui seront livrés.",
  "v8c.webhooks.activation.confirmation_desactiver": "Désactiver ce webhook ? Aucun événement ne lui sera plus livré.",
  "v8c.webhooks.activation.desactive": "Webhook désactivé : plus aucun événement ne lui est livré.",
  "v8c.webhooks.activation.desactiver": "Désactiver le webhook",
  "v8c.webhooks.activation.echec": "Changement d’état impossible.",
  "v8c.webhooks.annuler": "Annuler",
  "v8c.webhooks.catalogue.libelle": "Catalogue des événements",
  "v8c.webhooks.catalogue.vide": "Aucun événement abonnable.",
  "v8c.webhooks.categorie.derogations": "Dérogations",
  "v8c.webhooks.categorie.membres": "Membres",
  "v8c.webhooks.categorie.projets": "Projets",
  "v8c.webhooks.categorie.sprints": "Sprints",
  "v8c.webhooks.categorie.versions": "Versions",
  "v8c.webhooks.champ.adresse": "Adresse de destination",
  "v8c.webhooks.champ.adresse_aide": "Adresse https ; l’hôte est vérifié par la plateforme (destinations autorisées, aucun réseau interne).",
  "v8c.webhooks.champ.evenements": "Événements abonnés",
  "v8c.webhooks.champ.nom": "Nom",
  "v8c.webhooks.cible.android": "Android",
  "v8c.webhooks.cible.compte_app_store": "Compte App Store",
  "v8c.webhooks.cible.compte_google_play": "Compte Google Play",
  "v8c.webhooks.cible.compte_microsoft_store": "Compte Microsoft Store",
  "v8c.webhooks.cible.ios": "iOS",
  "v8c.webhooks.cible.macos": "macOS",
  "v8c.webhooks.cible.windows": "Windows",
  "v8c.webhooks.code.CONFLIT_CONCURRENT": "Modifié entre-temps : relisez avant d’enregistrer.",
  "v8c.webhooks.code.CONTEXTE_INCOMPLET": "Contexte incomplet : rouvrez l’organisation.",
  "v8c.webhooks.code.DROIT_NON_TENU": "Vous ne tenez pas le droit exigé pour ce geste.",
  "v8c.webhooks.code.EGRESS_HOST_NOT_ALLOWED": "Hôte absent de la liste des destinations autorisées.",
  "v8c.webhooks.code.EGRESS_METADATA_BLOCKED": "Adresse refusée : métadonnées ou adresse locale de lien.",
  "v8c.webhooks.code.GARDE_DROIT_ABSENTE": "Geste non protégé par un droit : refusé.",
  "v8c.webhooks.code.RESOURCE_UNAVAILABLE": "Objet introuvable ou d’une autre organisation.",
  "v8c.webhooks.code.SANS_SESSION": "Session expirée : reconnectez-vous.",
  "v8c.webhooks.code.SIGNATURE_CIBLE_DIFFERENTE": "La nouvelle clé doit viser la même cible que l’ancienne.",
  "v8c.webhooks.code.SIGNATURE_EXPIRATION_ANTERIEURE": "L’expiration doit être postérieure à celle de l’ancienne clé.",
  "v8c.webhooks.code.SIGNATURE_EXPIRATION_PASSEE": "La date d’expiration est passée.",
  "v8c.webhooks.code.SIGNATURE_FORMAT_REFUSE": "Fichier ou identifiants illisibles pour cette cible.",
  "v8c.webhooks.code.VALIDATION_ERROR": "Saisie invalide : vérifiez les champs.",
  "v8c.webhooks.code.WEBHOOK_ADRESSE_INTERNE": "Adresse refusée : elle mène à un réseau interne.",
  "v8c.webhooks.code.WEBHOOK_DESACTIVE": "Webhook désactivé : activez-le pour envoyer un essai.",
  "v8c.webhooks.code.WEBHOOK_HTTPS_EXIGE": "L’adresse doit commencer par https://.",
  "v8c.webhooks.code.WEBHOOK_NOM_DEJA_PRIS": "Un webhook de ce nom existe déjà dans l’organisation.",
  "v8c.webhooks.col.actions": "Actions",
  "v8c.webhooks.col.derniere_livraison": "Dernière livraison",
  "v8c.webhooks.col.etat": "État",
  "v8c.webhooks.col.evenements": "Événements",
  "v8c.webhooks.col.nom": "Nom",
  "v8c.webhooks.confirmer": "Confirmer",
  "v8c.webhooks.creer.bouton": "Créer le webhook",
  "v8c.webhooks.creer.bouton_ouvrir": "Créer un webhook",
  "v8c.webhooks.creer.echec": "Création impossible.",
  "v8c.webhooks.creer.titre": "Créer un webhook d’organisation",
  "v8c.webhooks.desactive": "Désactivé",
  "v8c.webhooks.essai.bouton": "Envoyer un événement d’essai",
  "v8c.webhooks.essai.desactive": "Webhook désactivé : activez-le pour envoyer un essai.",
  "v8c.webhooks.essai.echec": "Essai impossible.",
  "v8c.webhooks.essai.reponse": "Réponse reçue : {{resultat}}",
  "v8c.webhooks.etat.chargement": "Chargement : {{quoi}}…",
  "v8c.webhooks.etat.en_cours": "En cours…",
  "v8c.webhooks.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v8c.webhooks.etat.introuvable": "{{quoi}} introuvable.",
  "v8c.webhooks.etat.reessayer": "Réessayer",
  "v8c.webhooks.etat.refus": "Accès refusé : {{quoi}}.",
  "v8c.webhooks.evenement.derogation.accordee": "Dérogation accordée",
  "v8c.webhooks.evenement.derogation.refusee": "Dérogation refusée",
  "v8c.webhooks.evenement.invitation.acceptee": "Invitation acceptée",
  "v8c.webhooks.evenement.membre.ajoute_au_projet": "Membre ajouté à un projet",
  "v8c.webhooks.evenement.membre.desactive": "Membre désactivé",
  "v8c.webhooks.evenement.membre.retire_du_projet": "Membre retiré d’un projet",
  "v8c.webhooks.evenement.projet.archive": "Projet archivé",
  "v8c.webhooks.evenement.projet.cree": "Projet créé",
  "v8c.webhooks.evenement.projet.desarchive": "Projet désarchivé",
  "v8c.webhooks.evenement.projet.renomme": "Projet renommé",
  "v8c.webhooks.evenement.projet.suppression_demandee": "Suppression de projet demandée",
  "v8c.webhooks.evenement.sprint.clos": "Sprint clos",
  "v8c.webhooks.evenement.version.deploiement_planifie": "Déploiement planifié",
  "v8c.webhooks.evenement.version.gel_declare": "Gel de version déclaré",
  "v8c.webhooks.evenement.webhook.essai": "Événement d’essai",
  "v8c.webhooks.fiche.cree": "Créé",
  "v8c.webhooks.fiche.libelle": "Webhook",
  "v8c.webhooks.fiche.modifie": "Modifié",
  "v8c.webhooks.fiche.par_le": "{{qui}}, {{date}}",
  "v8c.webhooks.fiche.titre": "Webhook de l’organisation",
  "v8c.webhooks.liste.aucune_livraison": "Aucune livraison",
  "v8c.webhooks.liste.intro": "Les webhooks de l’organisation envoient ses événements, signés, vers vos outils.",
  "v8c.webhooks.liste.libelle": "Webhooks",
  "v8c.webhooks.liste.titre": "Webhooks de l’organisation",
  "v8c.webhooks.liste.vide": "Aucun webhook dans l’organisation.",
  "v8c.webhooks.livraison.statut.en_attente": "En attente",
  "v8c.webhooks.livraison.statut.en_echec": "En échec",
  "v8c.webhooks.livraison.statut.reussie": "Réussie",
  "v8c.webhooks.livraisons.essai": "essai",
  "v8c.webhooks.livraisons.libelle": "Livraisons récentes",
  "v8c.webhooks.livraisons.nouvelle_tentative": "Nouvelle tentative prévue le {{date}}",
  "v8c.webhooks.livraisons.titre": "Livraisons récentes",
  "v8c.webhooks.livraisons.vide": "Aucune livraison récente.",
  "v8c.webhooks.modifier.bouton": "Enregistrer la modification",
  "v8c.webhooks.modifier.bouton_ouvrir": "Modifier le webhook",
  "v8c.webhooks.modifier.conflit": "Ce webhook a été modifié entre-temps : relisez-le avant d’enregistrer.",
  "v8c.webhooks.modifier.echec": "Modification impossible.",
  "v8c.webhooks.modifier.effets": "Effets de la modification",
  "v8c.webhooks.modifier.livraisons_en_attente": "Les livraisons en attente partent vers la nouvelle adresse.",
  "v8c.webhooks.modifier.nouvelle_verification": "La nouvelle destination sera vérifiée à nouveau par la plateforme.",
  "v8c.webhooks.modifier.relire": "Relire",
  "v8c.webhooks.modifier.rien": "Rien à enregistrer : aucune modification.",
  "v8c.webhooks.modifier.secret_inchange": "Le secret de signature reste inchangé.",
  "v8c.webhooks.modifier.titre": "Modifier un webhook d’organisation",
  "v8c.webhooks.modifier.vise": "Webhook « {{nom}} », version {{version}}.",
  "v8c.webhooks.onglet.apercu": "Aperçu",
  "v8c.webhooks.onglet.webhooks": "Webhooks",
  "v8c.webhooks.onglets": "Sections de l’organisation",
  "v8c.webhooks.projets.actif_un": "{{n}} actif",
  "v8c.webhooks.projets.actifs": "{{n}} actifs",
  "v8c.webhooks.projets.desactive_un": "{{n}} désactivé",
  "v8c.webhooks.projets.desactives": "{{n}} désactivés",
  "v8c.webhooks.projets.explication": "Chaque projet administre ses propres webhooks ; ils sont comptés ici pour information.",
  "v8c.webhooks.projets.libelle": "Webhooks des projets",
  "v8c.webhooks.projets.ligne": "{{nom}} : {{actifs}}, {{desactives}}",
  "v8c.webhooks.projets.titre": "Webhooks des projets",
  "v8c.webhooks.projets.vide": "Aucun projet n’a de webhook.",
  "v8c.webhooks.renouveler.bouton": "Renouveler le secret",
  "v8c.webhooks.renouveler.confirmation": "L’ancien secret cessera aussitôt de valoir : vos outils devront utiliser le nouveau. Renouveler ?",
  "v8c.webhooks.renouveler.confirmer": "Renouveler maintenant",
  "v8c.webhooks.renouveler.echec": "Renouvellement impossible : l’ancien secret reste valable.",
  "v8c.webhooks.renouveler.fait": "Secret renouvelé : l’ancien ne vaut plus.",
  "v8c.webhooks.secret.copie": "Secret copié.",
  "v8c.webhooks.secret.copie_refusee": "Le navigateur a refusé la copie : sélectionnez le secret et copiez-le.",
  "v8c.webhooks.secret.copier": "Copier le secret",
  "v8c.webhooks.secret.doublon": "Cette création était déjà enregistrée : le secret a été montré à la première soumission.",
  "v8c.webhooks.secret.jamais_reaffiche": "Le secret de signature n’est jamais réaffiché ; renouvelez-le si vous l’avez perdu.",
  "v8c.webhooks.secret.titre": "Secret de signature",
  "v8c.webhooks.secret.une_fois": "Ce secret n’est montré qu’une fois : copiez-le maintenant dans votre outil.",
  "v8c.webhooks.secret.valeur": "Secret",
  "v8c.webhooks.signature.hmac": "Chaque envoi est signé (HMAC-SHA256 du corps, en-tête X-DoIt-Signature) avec le secret du webhook.",
  "v8c.webhooks.signature.titre": "Signature des envois",
  "v8c.webhooks.signature.une_fois": "Le secret de signature n’est montré qu’une fois, après la création.",
  "v8c.webhooks.signature_app.aide_identifiants.compte_app_store": "Champs attendus : issuer_id, key_id, private_key (PEM).",
  "v8c.webhooks.signature_app.aide_identifiants.compte_google_play": "Compte de service Google : type, client_email, private_key (PEM).",
  "v8c.webhooks.signature_app.aide_identifiants.compte_microsoft_store": "Champs attendus : tenant_id, client_id, client_secret.",
  "v8c.webhooks.signature_app.applications": "Applications qui l’utilisent : {{n}}",
  "v8c.webhooks.signature_app.applications_inconnues": "Applications qui l’utilisent : compte fourni par la construction signée (à venir).",
  "v8c.webhooks.signature_app.champ.cible": "Cible",
  "v8c.webhooks.signature_app.champ.expiration": "Date d’expiration",
  "v8c.webhooks.signature_app.champ.fichier": "Fichier de la clé (PKCS#12, keystore ou certificat)",
  "v8c.webhooks.signature_app.champ.identifiants": "Identifiants du compte (JSON)",
  "v8c.webhooks.signature_app.champ.mot_de_passe": "Mot de passe du fichier",
  "v8c.webhooks.signature_app.champ.nouveau_fichier": "Fichier de la nouvelle clé (PKCS#12, keystore ou certificat)",
  "v8c.webhooks.signature_app.choisie.aucune": "Choisissez une clé pour voir son empreinte et son expiration.",
  "v8c.webhooks.signature_app.choisie.titre": "Clé choisie",
  "v8c.webhooks.signature_app.choisir": "Choisir",
  "v8c.webhooks.signature_app.choisir_d_abord": "Choisissez d’abord une clé.",
  "v8c.webhooks.signature_app.choisir_la_cle": "Choisir {{nom}}",
  "v8c.webhooks.signature_app.cle_libelle": "Clé de signature",
  "v8c.webhooks.signature_app.col.cible": "Cible",
  "v8c.webhooks.signature_app.col.expire_le": "Expire le",
  "v8c.webhooks.signature_app.dialogue_titre": "Enregistrer une clé de signature ou un compte de magasin",
  "v8c.webhooks.signature_app.empreinte": "Empreinte",
  "v8c.webhooks.signature_app.enregistree": "Enregistrée",
  "v8c.webhooks.signature_app.enregistrement_echec": "Enregistrement impossible.",
  "v8c.webhooks.signature_app.enregistrer": "Enregistrer une clé",
  "v8c.webhooks.signature_app.enregistrer_la_cle": "Enregistrer la clé",
  "v8c.webhooks.signature_app.expiration_lue": "Laissée vide, elle est lue du certificat.",
  "v8c.webhooks.signature_app.expiration_passee": "La date d’expiration est passée.",
  "v8c.webhooks.signature_app.intro": "Clés de signature et comptes de magasin de l’organisation, utilisés par la construction signée des versions.",
  "v8c.webhooks.signature_app.jamais_reaffiche": "Le matériau d’une clé (fichier, mot de passe, identifiants) n’est jamais réaffiché.",
  "v8c.webhooks.signature_app.liste.libelle": "Clés de signature",
  "v8c.webhooks.signature_app.liste.vide": "Aucune clé de signature ni compte de magasin.",
  "v8c.webhooks.signature_app.onglet.catalogue_technologique": "Catalogue technologique",
  "v8c.webhooks.signature_app.onglet.charte": "Charte",
  "v8c.webhooks.signature_app.onglet.chemin_dore": "Chemin doré",
  "v8c.webhooks.signature_app.onglet.derogations": "Dérogations",
  "v8c.webhooks.signature_app.onglet.exigences": "Exigences",
  "v8c.webhooks.signature_app.onglet.regles": "Règles en trois temps",
  "v8c.webhooks.signature_app.onglet.sante": "Santé de la conformité",
  "v8c.webhooks.signature_app.onglets": "Sections de la gouvernance",
  "v8c.webhooks.signature_app.plus_active": "Clé retirée ou remplacée : geste indisponible.",
  "v8c.webhooks.signature_app.proposer_remplacement": "Expire bientôt : remplacez-la avant son expiration.",
  "v8c.webhooks.signature_app.remplacement.ancienne_valable": "L’ancienne clé reste valable jusqu’à la confirmation.",
  "v8c.webhooks.signature_app.remplacement.cle_remplacee": "Clé remplacée",
  "v8c.webhooks.signature_app.remplacement.confirmer": "Confirmer le remplacement",
  "v8c.webhooks.signature_app.remplacement.echec": "Remplacement impossible : l’ancienne clé reste seule valable.",
  "v8c.webhooks.signature_app.remplacement.echec_ancienne_seule": "Si la confirmation échoue, l’ancienne reste seule valable et la nouvelle n’est pas gardée.",
  "v8c.webhooks.signature_app.remplacement.effets": "Effets du remplacement",
  "v8c.webhooks.signature_app.remplacement.retiree": "Cette clé n’est plus active (retirée ou remplacée entre-temps) : rien à remplacer.",
  "v8c.webhooks.signature_app.remplacement.titre": "Remplacer une clé de signature",
  "v8c.webhooks.signature_app.remplacement.versions_suivantes": "Les versions suivantes seront signées par la nouvelle.",
  "v8c.webhooks.signature_app.remplacer": "Remplacer la clé",
  "v8c.webhooks.signature_app.requise_en_production": "Requise en production.",
  "v8c.webhooks.signature_app.retrait.bouton": "Retirer la clé",
  "v8c.webhooks.signature_app.retrait.confirmation": "Retirer « {{nom}} » ? Les versions suivantes ne seront plus signées avec elle.",
  "v8c.webhooks.signature_app.retrait.confirmer": "Retirer définitivement",
  "v8c.webhooks.signature_app.retrait.echec": "Retrait impossible.",
  "v8c.webhooks.signature_app.retrait.fait": "Clé retirée ; le retrait est écrit au journal.",
  "v8c.webhooks.signature_app.sous_onglet.catalogue": "Catalogue",
  "v8c.webhooks.signature_app.sous_onglet.categories": "Catégories",
  "v8c.webhooks.signature_app.sous_onglet.changements": "Changements",
  "v8c.webhooks.signature_app.sous_onglet.elements_qualifies": "Éléments qualifiés",
  "v8c.webhooks.signature_app.sous_onglet.nouvelles_piles": "Nouvelles piles et suggestions",
  "v8c.webhooks.signature_app.sous_onglet.radar": "Radar",
  "v8c.webhooks.signature_app.sous_onglet.signature": "Signature des applications",
  "v8c.webhooks.signature_app.sous_onglets": "Sections du catalogue technologique",
  "v8c.webhooks.signature_app.statut.active": "Active",
  "v8c.webhooks.signature_app.statut.expire_bientot": "Expire bientôt",
  "v8c.webhooks.signature_app.statut.expiree": "Expirée",
  "v8c.webhooks.signature_app.statut.remplacee": "Remplacée",
  "v8c.webhooks.signature_app.statut.retiree": "Retirée",
  "v8c.webhooks.signature_app.titre": "Signature des applications",
  "v8c.webhooks.suppression.bouton": "Supprimer le webhook",
  "v8c.webhooks.suppression.confirmation": "Supprimer définitivement « {{nom}} » et ses livraisons ?",
  "v8c.webhooks.suppression.confirmer": "Supprimer définitivement",
  "v8c.webhooks.suppression.echec": "Suppression impossible : la fiche reste ouverte, réessayez.",
  "v8c.webhooks.suppression.faite": "Webhook « {{nom}} » supprimé.",
  "v8c.webhooks.tous_les_webhooks": "Tous les webhooks",
  "v8c.webhooks.validation.aucun_evenement": "Choisissez au moins un événement.",
  "v8c.webhooks.validation.https": "L’adresse doit commencer par https://.",
  "v8c.webhooks.validation.nom": "Nom obligatoire, 100 caractères au plus.",
  "v8c.webhooks.voir": "Voir",
  "v8c.webhooks.voir_le_webhook": "Voir le webhook {{nom}}"
}
